import React from "react";
import me from "../../../../assets/logo/me.png";
import resume from "../../../../../src/resume.pdf";
import scroll from "../../../../AnimatedIcons/scroll.json";
import Lottie from "lottie-react";

const HeroSection = () => {
  return (
    <div className="bg-primary">
      <div class="flex lg:flex-row md:flex-col sm:flex-col flex-col justify-center gap-10 pt-32">
        <img
          src={me}
          className="w-96 hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 lg:mx-0 md:mx-auto"
          alt=""
        />
        <div class="flex justify-center items-start flex-col lg:mx-0 md:mx-auto">
          <h2 className="lg:text-5xl md:text-3xl sm:text-2xl text-2xl text-accent font-medium hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-green-400 lg:mx-0 md:mx-auto sm:mx-auto mx-auto">
            HI, I AM
          </h2>
          <h2 className="lg:text-8xl md:text-6xl sm:text-3xl text-3xl text-accent font-light hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-yellow-500 lg:mx-0 md:mx-auto sm:mx-auto mx-auto">
            FARHAN HASIN DIPRO.
          </h2>
          <h2 className="lg:text-7xl md:text-4xl sm:text-xl text-xl  font-bold text-success pb-6 hover:scale-110 hover:-rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-green-400 lg:mx-0 md:mx-auto sm:mx-auto mx-auto">
            VISUALIZER + WEB DEVELOPER
          </h2>
          <h2 className="lg:text-3xl md:text-xl sm:text-xs text-xs font-light text-success pb-6 hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-yellow-500 lg:mx-0 md:mx-auto sm:mx-auto mx-auto">
            I create visually stunning, interactive, and responsive websites.
          </h2>
          <a
            href={resume}
            target="_blank"
            rel="noreferrer"
            className="border-b-green-500 text-green-500 hover:border-green-600 hover:text-green-600 text-xl border-b-2 transition-all ease-in-out duration-700 hover:cursor-pointer lg:mx-0 md:mx-auto sm:mx-auto mx-auto"
          >
            RESUME
          </a>
        </div>
      </div>
      <div className="flex justify-center pt-14 pb-56">
        {/* <iframe
          src="https://lottie.host/?file=dd05b758-934e-412b-b2fc-61768151f617/u1l0mW4Lu8.json"
          title="scroll"
          className="w-40"
        ></iframe> */}
        <Lottie animationData={scroll} className="w-40"></Lottie>
      </div>
    </div>
  );
};

export default HeroSection;
